<template>
    <v-container color="primary">
        <v-row justify-md="center" wrap>
            <!-- Corrección: Usa <v-col> como componente -->
            <v-col md="6">
                <div v-if="!isAutomatic">
                    <MaterialfyDataCard v-if="bot" cardMaxWidth="500" cardTitle="DATOS" cardInnerText="Users Usering"
                        :cardShowDivider="false" :cardShowActions="false" cardColor="primary" :cardShowSubHeader="false"
                        :cardShowAutomatic="false" @action-clicked="handleActionStatus" ref="dataCard" :data="bot">
                        <template v-slot:crdInner>
                            <!-- <materialfy-apex-donut /> -->
                        </template>
                    </MaterialfyDataCard>
                    <p v-else-if="loading">Cargando...</p>
                    <p v-else-if="error">Error al cargar los datos.</p>
                </div>
                <div v-if="isAutomatic">
                    <MaterialfyDataCard v-if="bot" cardMaxWidth="500" cardTitle="DATOS" cardInnerText="Users Usering"
                        :cardShowDivider="false" :cardShowActions="false" cardColor="primary" :cardShowSubHeader="false"
                        :cardShowAutomatic="true" @action-clicked="handleActionStatus" ref="dataCard" :data="bot">
                        <template v-slot:crdInner>
                            <!-- <materialfy-apex-donut /> -->
                        </template>
                    </MaterialfyDataCard>
                    <p v-else-if="loading">Cargando...</p>
                    <p v-else-if="error">Error al cargar los datos.</p>
                </div>
            </v-col>

            <!-- Corrección: Usa <v-col> como componente -->
            <v-col md="6">
                <MaterialfyBasicCard :cardShowTitle="false">
                    <!-- Header -->
                    <template v-slot:crdSubHeader>
                        <!-- add new tabs under -->
                        <v-tabs align-with-title background-color="tertiary" class="elevation-3 mb-1" center-active>
                            <span class="text-subtitle-1 mr-1 d-flex align-center">
                                <v-icon class="ma-1">mdi-ballot</v-icon> Beneficios del Bot:
                            </span>
                            <v-tabs-slider color="secondary"></v-tabs-slider>

                        </v-tabs>
                    </template>
                    <!-- Card inner area for tab content -->
                    <template #crdInner>
                        <MaterialfyDataChart v-if="bot" ref="dataChart" :cardShowTitle="false" :data="bot" />
                        <p v-else-if="loading">Cargando...</p>
                        <p v-else-if="error">Error al cargar los datos.</p>
                    </template>
                </MaterialfyBasicCard>

                <!-- <materialfy-header-card cardTitle="ORDENES" text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false" :cardShowActions="false">
                    <template v-slot:crdInner>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br />
                        <MaterialfyDataTables ref="dataTable" cardTitle="API" :showSearch="false" :actions="actions"
                            :hasActions="false" @action-clicked="handleActionClicked" :showCardTitle="false" />
                        <br />
                    </template>
                </materialfy-header-card> -->
            </v-col>
        </v-row>
        <v-row justify-md="center" wrap>
            <!-- Corrección: Usa <v-col> como componente -->
            <v-col md="1"></v-col>
            <v-col md="10">
                <materialfy-header-card cardTitle="ORDENES" text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false" :cardShowActions="false">
                    <template v-slot:crdInner>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br />
                        <MaterialfyDataTables ref="dataTable" cardTitle="" :showSearch="false" :actions="actions"
                            :hasActions="false" @action-clicked="handleActionClicked" :showCardTitle="true" />
                        <br />
                    </template>
                    <!-- <template #crdActions>
                        <br />
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br />
                        <v-row no-gutters justify="center">
                            <v-btn color="tertiary" @click="menuActionClick('openDialogBot')" class="mb-2">
                                NUEVA API
                            </v-btn>
                        </v-row>
                        <br />
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br />
                    </template> -->
                </materialfy-header-card>
            </v-col>
        </v-row>
        <v-row>
            <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
                :float-right="right">
                <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                <div>
                    {{ msg_toast }}
                </div>
                <v-icon size="16" @click="closeAlert">
                    mdi-close-circle
                </v-icon>
            </v-snackbar>
        </v-row>
    </v-container>

</template>

<script>
import UserService from '@/services/user.service'

export default {
    name: "BotsOrdersView",
    data: () => ({
        title: 'Bots Orders',
        bot: null,
        loading: true,
        error: false,
        headers: [
            { text: 'Fecha Compra', value: 'fechaCompra', align: 'center' },
            { text: 'Precio Compra', value: 'precioCompra', align: 'center' },
            { text: 'Fecha Venta', value: 'fechaVenta', align: 'center' },
            { text: 'Precio Venta', value: 'precioVenta', align: 'center' },
            { text: 'Volumen', value: 'amountCompra', align: 'center' },
            { text: 'Beneficio', value: 'profitsTrade', align: 'center' },
            { text: 'Comision', value: 'comisionesTrade', align: 'center' }
        ],
        items: [],
        headersAutoBot: [
            { text: 'Par', value: 'symbol', align: 'center' },
            { text: 'Fecha Compra', value: 'fechaCompra', align: 'center' },
            { text: 'Precio Compra', value: 'precioCompra', align: 'center' },
            { text: 'Fecha Venta', value: 'fechaVenta', align: 'center' },
            { text: 'Precio Venta', value: 'precioVenta', align: 'center' },
            { text: 'Volumen', value: 'amountCompra', align: 'center' },
            { text: 'Beneficio', value: 'profitsTrade', align: 'center' },
            { text: 'Comision', value: 'comisionesTrade', align: 'center' }
        ],
        itemsAutoBot: [],
        actions: [],
        isAutomatic: false,
        // SanckBar
        color: null,
        colors: ["purple", "info", "success", "warning", "error"],
        top: true,
        bottom: false,
        left: false,
        right: false,
        dialogElegirBot: false,
        snackbar: false,
        msg_title: '',
        msg_toast: '',
        jsonFields: {}

    }),
    async created() {
        try {
            // console.log(this.$refs.dataChart)
            // Declare a variable
            let isUndefined;

            // Condition to check variable is defined or not
            // console.log(this.$store.state.auth.user.roles[0])
            if (typeof this.$route.params.idBot === 'undefined') {
                isUndefined = true;
            } else {
                isUndefined = false;
            }
            if (this.$route.params.idBot !== null && !isUndefined) {
                this.idBot = this.$route.params.idBot
                UserService.getBot(this.idBot).then(
                    response => {
                        this.bot = response.data
                        // console.log(this.bot)
                        this.isAutomatic = this.bot.automatico
                        if (this.isAutomatic) {
                            this.$refs.dataTable.headers = this.headersAutoBot                            
                        } else {
                            this.$refs.dataTable.headers = this.headers
                            this.$refs.dataTable.jsonFields = this.headers
                        }

                        // this.initData(this.idBot, false, this.bot.active)
                        // // this.$refs.ordersData.initData(this.idBot, false, this.bot.active)
                        // this.$refs.dataChart.loadUserChart(this.bot.id, 2025)
                        this.getOrders()
                    },
                    error => {
                        this.content =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        if (error.response && error.response.status === 403 || error.response.status === 401) {
                            this.$store
                                .dispatch('logout', this.user) //calls the login action and passes login info
                                .then(() => this.$router.push('/')) //redirect to dash after login
                                .catch((err) => {
                                    console.log(err)
                                    this.snackbar = true //shows error on wrong pass
                                })
                        }
                    }
                );
            }
        } catch (err) {
            this.error = true
            console.error('Error al cargar los datos:', err)
        } finally {
            this.loading = false
        }
    },
    mounted() { },
    methods: {
        handleActionClicked() { },
        // handleActionStatus({ item, action }) {
        handleActionStatus() {
            // console.log(item)
            // console.log(action)
            this.statusBot()
        },
        getOrders() {
            UserService.getTradesBot(this.idBot).then(
                response => {
                    this.items = response.data
                    // console.log(this.items)
                    // // let result = Object.fromEntries(this.items.map(e => e.split(":")))
                    // let jsonString = JSON.stringify(this.items)
                    // console.log(jsonString)
                    // let result = Object.fromEntries(this.jsonString.map(e => [e.key, e.value]));
                    // console.log(result)
                    this.$refs.dataTable.items = this.items
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        statusBot() {
            // console.log('STATUS BOT')
            // console.log(this.bot)
            if (this.bot.started === false) {
                this.start = true
                this.msgBtn = 'STOP'
                this.colors = 'error'
                // console.log('INICIAR BOT')
                // Iniciar bot
                this.sendStatus(true)
            } else {
                this.start = false
                this.msgBtn = 'START'
                this.colors = 'success'
                // console.log('PAUSE BOT')
                // Parar bot
                this.pauseBot(false)
            }
        },
        sendStatus(status) {
            this.message = ''
            this.submitted = true
            this.bot.started = status
            // console.log('ENTRA SEND STATUS')
            if (this.isAutomatic) {
                UserService.postStatusBotAuto(this.bot).then(
                    response => {
                        this.idBot = response.bot.id
                        this.$refs.dataCard.initData(this.idBot, this.isAdmin, this.isActive)
                        setTimeout(() => (this.responseChangeStartedBot('success', 'INICIAR BOT', 'Bot iniciado!!!')), 1000)
                    },
                    error => {
                        this.content =
                            (error.response && error.response.data && error.response.data.message) ||
                            error.message ||
                            error.toString()
                        setTimeout(() => (this.responseChangeStartedBot('error', 'INICIAR BOT', this.msgError)), 1000)
                    }
                )
            } else {
                UserService.postStatusBot(this.bot).then(
                    response => {
                        this.idBot = response.bot.id
                        this.$refs.dataCard.initData(this.idBot, this.isAdmin, this.isActive)
                        setTimeout(() => (this.responseChangeStartedBot('success', 'INICIAR BOT', 'Bot iniciado!!!')), 1000)
                    },
                    error => {
                        this.content =
                            (error.response && error.response.data && error.response.data.message) ||
                            error.message ||
                            error.toString()
                        setTimeout(() => (this.responseChangeStartedBot('error', 'INICIAR BOT', this.msgError)), 1000)
                    }
                )
            }

        },
        pauseBot(status) {
            this.message = ''
            this.submitted = true
            this.bot.started = status
            UserService.pauseBot(this.bot).then(
                response => {
                    this.idBot = response.id
                    this.$refs.dataCard.initData(this.idBot, this.isAdmin, this.isActive)
                    setTimeout(() => (this.responseChangeStartedBot('success', 'PARAR BOT', 'Bot parado!!!')), 1000)
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString()
                    setTimeout(() => (this.responseChangeStartedBot('error', 'PARAR BOT', this.msgError)), 1000)
                }
            );
        },
        responseChangeStartedBot(response, title, msg) {
            // console.log(response)
            this.top = true;
            this.bottom = false;
            this.left = false;
            this.right = false;
            this.msg_toast = msg
            this.snackbar = true;

            if (response === 'success') {
                this.color = 'success'
                this.successful = true
            } else {
                this.color = 'error'
                this.successful = false
            }
        },
        loadUserChart(value) {
            UserService.getChartBot(value, 2024).then(
                response => {
                    this.totalBeneficios = response.data
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        closeAlert() {
            this.snackbar = false
            this.loading = false
        }
    },
};
</script>

<style></style>
